@if (text()) {
    <span>{{ text() }}</span>
}
